import styled from "styled-components";

export const Wrapper = styled("div")`
  height: calc(100vh - 56px);
  width: 100%;
`;
